module.exports = __webpack_public_path__ + "img/SketchPnga8f752c1e5181b59fec6498207ed241d9b9012b3771e9675fd82d2d8d849909f.6fb78608.png";